export default {"src":"/_next/static/media/buySellLockInRate.c0c96af9.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};